// Color palette derived from colors.txt
export const colors = {
  primary: '#3C82F6',    // Blue
  secondary: '#C1FF72',  // Green
  dark: '#1E293B',       // Black
  
  // Extended palette
  background: {
    default: '#f8fafc',
    paper: '#ffffff',
    light: '#f1f5f9',
  },
  text: {
    primary: '#1E293B',
    secondary: '#64748b',
    light: '#94a3b8',
  },
  success: '#C1FF72',
  info: '#3C82F6',
  warning: '#f59e0b',
  error: '#ef4444',
};

export default colors;